var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row col-12 div-principal-video"},[_c('div',{staticClass:"col-8 div-single-video"},[_c('single-video-painel')],1),_c('div',{staticClass:"col-3 div-single-menu"},[_c('menu-videos')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }